export default __webpack_public_path__ + "static/media/img19.e2906fe7.png";